import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TutorialService {
    private _isTutorialActive = new BehaviorSubject<boolean>(false);
    isTutorialActive$ = this._isTutorialActive.asObservable();

    toggleTutorial(): void {
        this._isTutorialActive.next(!this._isTutorialActive.value);
    }

    stopTutorial(): void {
        this._isTutorialActive.next(false);
    }
}
